import { Component, Input, OnInit } from '@angular/core';

import { PageEvent } from '@angular/material/paginator';
import { TripsTableComponent } from '@components';
import { Trip, User } from '@models';
import { TripService } from '@services';

@Component({
  selector: 'app-trips',
  standalone: true,
  imports: [TripsTableComponent],
  templateUrl: './trips.component.html',
  styleUrl: './trips.component.scss',
})
export class TripsComponent implements OnInit {
  @Input() user: User | null = null;

  columns: string[] = [
    'totalWeight',
    'totalVolume',
    'plannedAt',
    'completedAt',
    'status',
  ];

  columnLabels: Record<string, string> = {
    totalWeight: 'Total Weight (kg)',
    totalVolume: 'Total Volume (cm³)',
    plannedAt: 'Planned At',
    completedAt: 'Completed At',
    status: 'Status',
  };

  public loading: boolean = true;
  public pageSize: number = 20;
  public pageIndex: number = 0;
  public totalTrips: number = 0;
  public trips: Trip[] = [];

  constructor(private tripService: TripService) {}

  public ngOnInit(): void {
    this.fetchTripsPage();
  }

  public onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.fetchTripsPage();
  }

  private async fetchTripsPage(): Promise<void> {
    this.loading = true;

    try {
      const response = await this.tripService.getPage({
        where: { driverId: this.user!.id! },
        offset: this.pageIndex * this.pageSize,
        limit: this.pageSize,
      });
      this.totalTrips = response.count;
      this.trips = response.data;
    } catch (error) {
      console.error('Error occurred during fetching trips page', {
        cause: error,
      });
    }

    this.loading = false;
  }
}
